module.exports = __webpack_public_path__ + "img/chamor_no.8e88d08e.png";